(function() {
    'use strict';

    angular
        .module('bluebookApp')
        .controller('CrmCallDeleteController',CrmNoteDeleteController);

    CrmNoteDeleteController.$inject = ['$uibModalInstance', 'entity', 'CrmCall'];

    function CrmNoteDeleteController($uibModalInstance, entity, CrmCall) {
        var vm = this;

        vm.crmCall = entity;
        vm.clear = clear;
        vm.confirmDelete = confirmDelete;

        function clear () {
            $uibModalInstance.dismiss('cancel');
        }

        function confirmDelete (id) {
            CrmCall.delete({id: id},
                function () {
                    $uibModalInstance.close(true);
                });
        }
    }
})();
